"use client";

import { c as _c } from "react/compiler-runtime";
import { TabMenu, TabMenuItem, TabMenuItemTitle } from "@opensea/next-ui-kit";
import { Tooltip } from "@opensea/ui-kit";
import { useTranslations } from "next-intl";
import { useNavigationContainerClassNames, useNavigationTabMenuClassNames } from "../navigation/constants";
import { useCollectionTabs } from "./use-collection-tabs";
export function CollectionNavigationSkeleton() {
  const $ = _c(8);
  const tabs = useCollectionTabs(undefined);
  const navigationTabMenuClassNames = useNavigationTabMenuClassNames();
  const navigationContainerClassNames = useNavigationContainerClassNames();
  let t0;
  if ($[0] !== tabs) {
    t0 = tabs.map(_temp);
    $[0] = tabs;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== navigationTabMenuClassNames || $[3] !== t0) {
    t1 = <TabMenu aria-label="Collection" className={navigationTabMenuClassNames}>{t0}</TabMenu>;
    $[2] = navigationTabMenuClassNames;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== navigationContainerClassNames || $[6] !== t1) {
    t2 = <div className={navigationContainerClassNames}>{t1}</div>;
    $[5] = navigationContainerClassNames;
    $[6] = t1;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  return t2;
}
function _temp(tab) {
  return <CollectionNavigationSkeletonItem key={tab.href} tab={tab} />;
}
function CollectionNavigationSkeletonItem(t0) {
  const $ = _c(12);
  const {
    tab
  } = t0;
  const t = useTranslations("CollectionNavigation");
  let t1;
  if ($[0] !== t) {
    t1 = t("comingSoon");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const t2 = !tab.disabled;
  let t3;
  if ($[2] !== tab.title) {
    t3 = <TabMenuItemTitle>{tab.title}</TabMenuItemTitle>;
    $[2] = tab.title;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t3 || $[5] !== tab.disabled) {
    t4 = <div><TabMenuItem disabled={tab.disabled}>{t3}</TabMenuItem></div>;
    $[4] = t3;
    $[5] = tab.disabled;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t1 || $[8] !== t2 || $[9] !== t4 || $[10] !== tab.title) {
    t5 = <Tooltip content={t1} disabled={t2} key={tab.title}>{t4}</Tooltip>;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
    $[10] = tab.title;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}